/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentWorkflowState } from './studentWorkflowState';

export type ModuleStateStudentWorkflowState = StudentWorkflowState | null;
